var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_infb inset-lg fixed-flex", class: _vm.theme },
    [
      _c(
        "div",
        { staticClass: "fs4" },
        [
          _vm.theme == "warning"
            ? [
                _c("svg", { attrs: { viewBox: "0 0 28 24" } }, [
                  _c("path", {
                    attrs: { fill: "#ffc107", d: "M0 24L14 0l14 24" }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: { fill: "#000", d: "M13 17.2l-.3-9h2.6l-.4 9h-2z" }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: { fill: "#000", cx: "14", cy: "20", r: "1.2" }
                  })
                ])
              ]
            : _vm.theme == "positive"
            ? [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M19.28 5.28L9 15.56l-4.28-4.28-1.44 1.44 5 5 .72.69.72-.7 11-11z"
                      }
                    })
                  ]
                )
              ]
            : _vm.theme == "negative"
            ? [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5 1.4 1.4-3.5 3.5z"
                      }
                    })
                  ]
                )
              ]
            : [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2zm0-8h-2V7h2z"
                      }
                    })
                  ]
                )
              ]
        ],
        2
      ),
      _c("div", { staticClass: "insetx-lg" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }